const translations = {
    'actions.build': 'Zbuduj',
    'actions.buildBlacksmith': 'Zbuduj kowala (%s)',
    'actions.buildCaravanPost': 'Zbuduj posterunek karawan (%s)',
    'actions.buildCharcoalPit': 'Zbuduj węgielnię (%s)',
    'actions.buildFarm': 'Zbuduj farmę (%s)',
    'actions.buildFishingHut': 'Zbuduj chatę rybacką (%s)',
    'actions.buildGoldMine': 'Zbuduj kopalnię złota (%s)',
    'actions.buildHouse': 'Zbuduj dom (%s)',
    'actions.buildHuntingHut': 'Zbuduj chatę myśliwską (%s)',
    'actions.buildIronMine': 'Zbuduj kopalnię żelaza (%s)',
    'actions.buildLumberjack': 'Zbuduj obóz drwali (%s)',
    'actions.buildMasonry': 'Zbuduj cegielnię (%s)',
    'actions.buildMint': 'Zbuduj mennicę (%s)',
    'actions.buildQuarry': 'Zbuduj kamieniołom (%s)',
    'actions.buildSawmill': 'Zbuduj tartak (%s)',
    'actions.buildSmelter': 'Zbuduj hutę (%s)',
    'actions.buildSmokehouse': 'Zbuduj wędzarnię (%s)',
    'actions.buildStable': 'Zbuduj stajnię (%s)',
    'actions.buildWeaver': 'Zbuduj tkacza (%s)',
    'actions.foundSettlement': 'Załóż osadę (%d pop)',
    'actions.cancel': 'Anuluj',
};

export default translations;
